(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize collapsible text functionality
    const collapsibleToggles = document.querySelectorAll('.collapsible-text-toggle');

    collapsibleToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        const content = this.closest('.collapsible-text-container').querySelector('.collapsible-text-content');
        const icon = this.querySelector('.toggle-icon');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        if (content) {
          if (isExpanded) {
            // Collapse - add the collapsed class to apply line-clamp
            content.classList.add('collapsed');
            this.setAttribute('aria-expanded', 'false');
            icon.textContent = '+';
          } else {
            // Expand - remove the collapsed class to show full text
            content.classList.remove('collapsed');
            this.setAttribute('aria-expanded', 'true');
            icon.textContent = '−';
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
